<template>
  <div id="app">
    <HelloWorld class="main" />
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
#app {
  width: 720px;
  height: 785px;
  zoom: 0.8;
  // margin-top: 20px;
  // margin-left: 20px;
  margin: auto;
  margin-top: 20px;
}
body,
html {
  background-color: transparent;
}

.main {
  // transform: scale(0.2);
  animation: main 1s ease-in-out forwards;
  overflow: hidden;
}
@keyframes main {
  0% {
    transform: scale(0);
    border-radius: 50%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    border-radius: 0%;
    opacity: 1;
    box-shadow: 0px 0px 15px #999999a9;
  }
}
</style>
